<template>
    <div>
        <collection-header></collection-header>

        <div class="collection-detail d-flex" v-if="results">
            <div class="left-side">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/">Main</a></li>
                        <li class="breadcrumb-item"><a href="/collections">Collections</a></li>
                        <li class="breadcrumb-item active" aria-current="page">{{ collection.name }}</li>
                    </ol>
                </nav>
                <instagram-widget></instagram-widget>
            </div>
            <div class="new-application-list">
                <h1>{{ collection.name }}</h1>
                <span>{{ results.length }} / update {{ collection.updated_at | moment("DD.MM.YYYY") }}</span>
                <div class="social-share">
                    <ShareNetwork
                        network="telegram" :title="'Racing'"
                        :url="shareUrl" hashtags="storeglide">
                        <img src="/img/share_telegram.svg">
                    </ShareNetwork>
                    <ShareNetwork
                        network="facebook" :title="'Racing'"
                        :url="shareUrl" hashtags="storeglide">
                        <img src="/img/share_fb.svg">
                    </ShareNetwork>
                    <ShareNetwork
                        network="linkedIn" :title="'Racing'"
                        :url="shareUrl" hashtags="storeglide">
                        <img src="/img/share_linkdin.svg">
                    </ShareNetwork>
                    <ShareNetwork
                        network="twitter" :title="'Racing'"
                        :url="shareUrl" hashtags="storeglide">
                        <img src="/img/share_twitter.svg">
                    </ShareNetwork>
                    <a href="#" @click.stop.prevent="copyUrl">
                        <img src="/img/share_link.svg"></a>

                </div>
                <ul class="apps-list">
                    <template v-for="(result, idx) in results">
                        <li class="app" ref="app">
                            <div class="content">
                                <div class="logo" v-if="result.icon">
                                    <img v-lazy="result.icon" :alt="result.name"/>
                                </div>
                                <div class="description">
                                    <span class="name">{{ result.name }}</span>
                                    <a class="author"
                                       href="#">{{
                                            result.publisher_name
                                        }}</a>
                                    <span
                                        class="date">{{
                                            result.release_date | moment("add", "7 hours") | moment("from", "now")
                                        }}</span><span
                                    class="release-date">First release: {{
                                        result.release_date | moment("YYYY-MM-DD")
                                    }}</span>
                                    <span class="countries"
                                          v-if="result.locations !== null && result.locations.length >= 5"
                                          v-b-tooltip.html="appCountries(result)"
                                          v-b-tooltip="{ trigger: 'hover', html: true, placement: 'bottom', customClass: 'v-country-tooltip'}">
                            {{ result.locations.length }}  countries
                            </span>
                                    <span class="countries"
                                          v-if="result.locations !== null && result.locations.length < 5">
                            <span v-for="(location, index) in result.locations">
                                {{ getLocationLabel(location) }}<span
                                v-if="index !== (result.locations.length - 1)">, </span>
                            </span>
                            </span>
                                </div>
                                <div class="additional">

                                    <a :href="result.url" class="download"
                                       v-bind:class="result.store_type == 'app_store' ? 'app-store' : 'play-market'"
                                       target="_blank"
                                       title="Go to App Store">Download</a>
                                    <div class="options">
                                        <social-share :id="idx" :url="shareUrl + '?app_id=' + idx"
                                                      title="'Racing'"></social-share>
                                        <img
                                            :src="user.id ? result.is_favourite ? '/img/fill_star.svg':'/img/stroke_star.svg' : '/img/disable_stroke_star.svg'"
                                            v-bind:class="{'disable': !user.id}"
                                            class="favourite-icon" @click="markFavourite(idx)"
                                            :id="'tooltip-' + result.id">

                                        <b-tooltip ref="tooltip" :target="'tooltip-' + result.id"
                                                   placement="bottom"
                                                   custom-class="disable-tooltip" :disabled="user.id != null">
                                            You must log in </br> to use this function!
                                        </b-tooltip>

                                    </div>

                                </div>

                            </div>

                            <div class="gallery-container" v-if="result.gallery">
                                <ul class="gallery">
                                    <li class="item" v-for="gallery in result.gallery">
                                        <img v-if="result.type == 'app_store'"
                                             v-lazy="imageFormatting(gallery)" alt="#"/>
                                        <img v-if="result.type != 'app_store'" v-lazy="gallery" alt="#"/>
                                    </li>
                                </ul>
                            </div>

                            <!--                        <div class="deconstruct">-->
                            <!--                            <h3>{{ result.collection_title }}</h3>-->
                            <!--                            <div v-html="result.collection_description"></div>-->
                            <!--                        </div>-->

                        </li>

                        <li class="mobile-instagram-widget" v-if="idx == 1">
                            <instagram-widget></instagram-widget>
                        </li>
                    </template>
                </ul>
            </div>
        </div>

        <mobile-menu></mobile-menu>
    </div>
</template>

<script>
import CollectionHeader from './custom/CollectionHeaderComponent';
import MobileMenu from './custom/MobileMenuComponent';

export default {
    name: 'App',
    components: {
        CollectionHeader,
        MobileMenu
    },
    props: ['collectionDetail'],
    data() {
        return {
            results: [],
            inProgress: false,
            countryList: [],
            user: {},
            shareUrl: window.location.href,
            scrollAppId: this.$route.query['app_id'] ? this.$route.query['app_id'] : null,
            collection: JSON.parse(this.collectionDetail)
        };

    },
    mounted() {
        this.loadUser();
        this.loadCountries();

    },
    updated() {
        if (this.scrollAppId) {
            this.scrollToApp();
        }
    },
    methods: {
        copyUrl() {
            let container = this.$refs.container
            this.$copyText(this.shareUrl, container);
            alert('Copied!');

        },
        loadApplications: function () {
            var params = {'collection-id': this.collection.id};

            if (this.user) {
                params['user-id'] = this.user.id
            }

            axios.get("/api/collection-applications", {params: params}).then(response => {
                this.results = response.data;
            });
        },
        scrollToApp() {

            var element = this.$refs.app[this.scrollAppId];
            var top = element.offsetTop;
            var width = $(window).width();
            if (width <= 991) {
                top = top - 60;
            }
            window.scrollTo(0, top);

            this.$router.push({}).catch(err => err);
            this.shareUrl = window.location.href;
        },
        loadMore: _.debounce(function (page = 0) {

            this.inProgress = true;
            var params = {page: page};

            if (this.user) {
                params['user-id'] = this.user.id
            }

            axios.get("/api/new-application", {
                params: params
            }).then(response => {

                this.results = response.data.data;
                this.inProgress = false;

            });
        }, 500),
        loadCountries: function () {
            axios.get("/api/countries").then(response => {

                this.countryList = response.data;

            });
        },
        loadUser: function () {
            axios.get("/auth/get-user").then(response => {
                this.user = response.data;
                this.loadApplications();
            });

        },
        imageFormatting(text) {
            return String(text).slice(0, -13) + '318x318bb.jpg';
        },
        markFavourite(id) {

            if (!this.user.id) {
                var root = this;
                root.$refs.tooltip[id].$emit('open');
                setTimeout(function () {
                    root.$refs.tooltip[id].$emit('close');
                }, 2000);
                return;
            }

            if (!this.results[id].is_favourite) {
                axios.post("/api/favourite/create", {
                    user_id: this.user.id,
                    app_id: this.results[id].id,
                    type: 'live'

                }).then(response => {
                    if (response.data.status) {
                        this.results[id].is_favourite = true;
                        this.results = JSON.parse(JSON.stringify(this.results));
                    }
                });

            } else {
                axios.post("/api/favourite/delete", {
                    user_id: this.user.id,
                    app_id: this.results[id].id,
                    type: 'live'
                }).then(response => {
                    if (response.data.status) {
                        this.results[id].is_favourite = false;
                        this.results = JSON.parse(JSON.stringify(this.results));
                    }
                    if (this.filterFavourites) {
                        this.results.splice(id, 1);
                    }

                });

            }

        },
        appCountries(result) {
            var countries = JSON.parse(JSON.stringify(this.countryList));
            var locations = result.locations;
            var count = locations.length;

            $.each(countries, function (i, item) {
                var valObj = locations.filter(function (elem) {
                    if (elem == item.code) return elem;
                });
                if (valObj.length > 0) {
                    item.active = 1;
                }
            });


            var htmlTemplate = '<p>Released in ' + count + ' countries:</p>';
            htmlTemplate += '<ul>';

            $.each(countries, function (i, item) {
                if (item.active) {
                    htmlTemplate += '<li class="active">' + item.label + '</li>';
                } else {
                    htmlTemplate += '<li>' + item.label + '</li>';
                }
            });

            htmlTemplate += '</ul>';


            return htmlTemplate;
        },
        getLocationLabel(code) {

            var location = this.countryList.filter(function (elem) {
                if (elem.code == code) return elem;
            });

            return location[0].label;
        },

    },

}

</script>
